<cx-generic-link [url]="url" [target]="target" [ariaLabel]="!label && tooltipText ? tooltipText : null">
  <i nz-icon [nzType]="type" nzTheme="{{ theme }}" [ngbTooltip]="tooltipText" [disableTooltip]="!tooltipText"></i>
  <p *ngIf="label">{{ label }}</p>
</cx-generic-link>
